export class SetupMongoAtlasPrivateLinkResponse {
    'workflowId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workflowId",
            "baseName": "workflowId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SetupMongoAtlasPrivateLinkResponse.attributeTypeMap;
    }
    constructor() {
    }
}
